import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setSubLoading } from '../../Redux/Services/AuthSlice';
import { NotificationSound } from '../CommonComponents/CommonNotification';
import { ApiCall, DropDownData, deleteData, initializeFilterData } from '../CommonComponents/CustomHooks';
import { BulkClearData, DownloadFileAtURL, ERRORDATALIST, HandleBulkInsertData, handleDownloadExcel, readFile } from '../CommonComponents/ExportData';
import { AutoCompleteBoxNew, FormButton, ImportButton, InputBox, SelectInputBox, Switch } from '../CommonComponents/InputBox';
import { Table } from '../CommonComponents/Table';
import { CommonApiData } from '../CommonComponents/EnvConfig';

const AssetMaster = () => {
    const inputrefs = useRef([])
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [tableData, setTableData] = useState([])
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const [filterData, setFilterData] = useState(initializeFilterData)
    const GetDealerType = DropDownData('GetDealerTypeMaster')
    const [Status, setStatus] = useState([])
    const [ImportData, setImportData] = useState([])
    const [Name, setName] = useState('');
    const [formData, setFormData] = useState({
        assetMasterID: '',
        assetCode: 'System Generated',
        assetName: '',
        assetTypeCode: '',
        dealerTypeCode:'',
        isIMEIApplicable: false,
        isActive: true
    });

    const getAssetMasterData = async (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        const data = {
            ...filterData,
            Type: 'S',
            PageIndex: `${PageIndex}`,
            ...sortConfig
        }
        setIsLoading(true)
        let res = await ApiCall(`/api/Master/ShowAssetMaster`, data)
        if (res.Status === "SUCCESS") {
            setTableData(res)
        }
        if (res.Status === "ERROR") {
            setTableData([])
        }
        setIsLoading(false)
        if (res.Status === 'EXPIRED' || res.Status === 'UNAUTHORIZED') {
            await NotificationSound(res.Status, res.Message, res.focus, inputrefs);
            setIsLoading(false)
        }
    }

    const handleClear = async() => {
        setFormData({
            assetMasterID: '',
            assetCode: 'System Generated',
            assetName: '',
            assetTypeCode: '',
            dealerTypeCode: '',
            isIMEIApplicable: false,
            isActive: true
        });
        await setImportData([])
        await BulkClearData(setName)
        await setName('')
        await setStatus([])
        filterData.SearchText = '';
        setSortConfig({ SortColumn: null, SortOrder: null })
    }

    const handleSubmit = async () => {
        await dispatch(setSubLoading(true))
        let data = await ApiCall(`/api/Master/InsertUpdateAssetMaster`, formData)
        await dispatch(setSubLoading(false))
        await NotificationSound(data.status, data.message, data.focus, inputrefs, handleClear);
    };

    const handleEditData = async (id) => {
        await dispatch(setSubLoading(true))
        let editData = await ApiCall(`/api/Master/EditAssetMaster`, { assetMasterID: id })
        await dispatch(setSubLoading(false))
        if (editData.status === 'UNAUTHORIZED' || editData.status === 'ERROR' || editData.status === 'EXPIRED') {
            await NotificationSound(editData.status, editData.message, editData.focus, inputrefs);
        }
        else {
            setFormData((pre) => ({
                ...pre, ...editData
            }))
        }
    }

    const handleDelete = async (id) => {
        await dispatch(setSubLoading(true))
        await deleteData(`/api/Master/DeleteAssetMaster`, { assetMasterID: id }, getAssetMasterData, handleClear, '', inputrefs)
        await dispatch(setSubLoading(false))
    }

    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';
        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };

    const handleChange1 = (event, value) => {
        getAssetMasterData(value);
    };
    const DownloadFormat = async () => {
        await DownloadFileAtURL('AssetMaster.xlsx')
    };

    const ErrorData = async () => {
        await ERRORDATALIST(Status, 'AssetMasterError')
    }

    const BulkSubmit = async (e) => {
        await dispatch(setSubLoading(true))
        let data = await readFile(e)
        setImportData(data.exceljson)
        setName(data.FileName)
        await dispatch(setSubLoading(false))
    };

    const handleBulk = async () => {
        const Data2 = {
            "authToken": CommonApiData().AuthToken,
            "loginToken": CommonApiData().LoginToken,
            "loginUserCode": CommonApiData().UserCode,
            "companyCode": CommonApiData().CompanyCode,
            assetCode: 'System Generated',

        };
        if (ImportData.length !== 0) {
            if ((Object.keys(ImportData[0])).includes("assetName", "assetTypeCode", "dealerTypeCode", "isIMEIApplicable", "isActive")) {
                await dispatch(setSubLoading(true))
                let Data = await HandleBulkInsertData('/api/Master/InsertUpdateAssetMaster', ImportData, Data2, getAssetMasterData)
                await setStatus(Data)
                await dispatch(setSubLoading(false))
                await NotificationSound('INFO', `Success : ${Data.SuccessCount} Error : ${Data.ErrorCount}`);
                BulkClearData(setName)

            } else {
                await NotificationSound('ERROR', 'Header Format is not valid !');
                BulkClearData(setName)
            }
        } else {
            await NotificationSound('ERROR', 'Please Choose File With Valid Data.!');
            BulkClearData(setName)
        }
    }
    useEffect(() => {
        getAssetMasterData()
        document.title = 'Asset Master'
        inputrefs.current['txtAssetName'].focus()
    }, [sortConfig])

    return (
        <>
            <div className='main-card card border-0'>
                <div className='pt-1 row px-3 border-0'>
                    <div className='card-header mb-1'>
                        <h6 className="m-0">  {'Asset Master'} </h6>
                    </div>
                    <div className='card-body pb-1 row'>
                        <div className='col-md-6 col-lg-8'>
                        <div className='row'>
                            <InputBox
                                id="txtAssetCode"
                                type="text"
                                divclassname="col-lg-4 col-md-4 col-sm-12 mb-1"
                                label='Asset Code'
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtAssetName'].focus()
                                    }
                                }}
                                inputrefs={inputrefs}
                                placeholder='System Generated'
                                name='AssetCode'
                                value={formData.assetCode}
                                disabled
                            />
                            <InputBox
                                id="txtAssetName"
                                divclassname="col-lg-4 col-md-4 col-sm-12 mb-1"
                                type="text"
                                label='Asset Name'
                                required={true}
                                placeholder="Asset Name"
                                maxLength='50'
                                value={formData.assetName}
                                onChange={(e) => setFormData({ ...formData, assetName: e.target.value })}
                                inputrefs={inputrefs}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtAssetTypeCode'].focus()
                                    }
                                }}
                            />
                            <AutoCompleteBoxNew
                                id="txtAssetTypeCode"
                                placeholder="Asset Type"
                                divclassname="col-lg-4 col-md-4 col-sm-12 mb-1"
                                label={'Asset Type'}
                                required={true}
                                inputrefs={inputrefs}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtDealerType'].focus()
                                    }
                                }}
                                contextKey={formData.assetTypeCode}
                                autocompleteType='GetAssetTypeMaster'
                                value={formData.assetTypeCode || ''}
                                onChange={async (event, newInputValue) => {
                                    newInputValue = newInputValue || ''
                                    if (event.type !== 'keydown') {
                                        setFormData({ ...formData, assetTypeCode: newInputValue })
                                    }
                                }}
                                maxLength='50'
                            />
                            <SelectInputBox
                                id="txtDealerType"
                                value={formData.dealerTypeCode}
                                divclassname="col-lg-4 col-md-4 col-sm-12 mb-1"
                                label='Dealer Type'
                                required={true}
                                onChange={(e) => setFormData({ ...formData, dealerTypeCode: e.target.value })}
                                inputrefs={inputrefs}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtIsIMEIApplicable'].focus()
                                    }
                                }}
                            >
                                <option value=''>--Please Select--</option>
                                {GetDealerType?.data?.dataList?.map((item, index) =>
                                    <option key={item.name + index} value={item.code}>{item.name}</option>
                                )}
                            </SelectInputBox>
                            <Switch
                                inputrefs={inputrefs}
                                label='IMEI Applicable'
                                checked={formData.isIMEIApplicable}
                                divclassname="col-lg-4 col-md-4 col-sm-12 mb-1"
                                id='txtIsIMEIApplicable'
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtActive'].focus()
                                    };
                                }}
                                onChange={(e) => setFormData({ ...formData, isIMEIApplicable: e.target.checked })}
                            />
                            <Switch
                                inputrefs={inputrefs}
                                label='Active'
                                checked={formData.isActive}
                                divclassname="col-lg-4 col-md-4 col-sm-12 mb-1"
                                id='txtActive'
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['btnSub'].focus()
                                    };
                                }}
                                onChange={(e) => setFormData({ ...formData, isActive: e.target.checked })}
                            />
                        </div>
                        </div>
                        <div className='d-flex col-md-6 col-lg-4 h-65 mb-2'>
                            <ImportButton
                                handleBulk={handleBulk}
                                BulkSubmit={(e) => BulkSubmit(e)}
                                downloadFormat={DownloadFormat}
                                ErrorData={ErrorData}
                                Status={Status}
                                HeaderFormat="PayMode, Active"
                                fileName={Name}
                            >
                            </ImportButton>
                        </div>
                   
                    <div className='card-body'>
                        <FormButton
                            id={'btnSub'}
                            inputrefs={inputrefs}
                            handleSubmit={handleSubmit}
                            handleExport={() => handleDownloadExcel(`/api/Master/ShowAssetMaster`, filterData, 'Asset Master')}
                            handleClear={handleClear}
                        />
                        </div>
                    </div>
                </div>
            </div>
            <Table
                handleEdit={handleEditData}
                handleDelete={handleDelete}
                loading={isLoading}
                PageName={'AssetMaster'}
                handleFilter={() => {
                    getAssetMasterData()
                    setFilterData({
                        ...filterData,
                    })
                }}
                filterData={filterData}
                tableData={tableData}
                setFilterData={setFilterData}
                currentPageNo={currentPageNo}
                handleChange1={handleChange1}
                handleSorting={handleSorting}
                sortConfig={sortConfig}
            />
        </>
    )
}
export default AssetMaster;